// Dashboard components
import MDButton from "components/MDButton";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const DownloadDataButton = ({ onClick, disabled, tooltip, ...props }) => {
  return (
    <Tooltip title={tooltip}>
      <MDButton
        onClick={onClick}
        disabled={disabled}
        iconOnly
        size="small"
        type="button"
        {...props}
        color={props?.style?.backgroundColor ? null : "success"}
        variant="outlined"
        style={
          disabled
            ? { backgroundColor: "grey", color: "white", marginRight: "1rem" }
            : props?.style
        }
      >
        <Icon>download</Icon>
      </MDButton>
    </Tooltip>
  );
};

export default DownloadDataButton;
